import { render } from "./UsuariosTable.vue?vue&type=template&id=36fa3dd1&scoped=true"
import script from "./UsuariosTable.vue?vue&type=script&lang=js"
export * from "./UsuariosTable.vue?vue&type=script&lang=js"

import "./UsuariosTable.vue?vue&type=style&index=0&id=36fa3dd1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fa3dd1"]])

export default __exports__